import { render, staticRenderFns } from "./MapField.vue?vue&type=template&id=3b920c94&scoped=true"
import script from "./MapField.vue?vue&type=script&lang=js"
export * from "./MapField.vue?vue&type=script&lang=js"
import style0 from "./MapField.vue?vue&type=style&index=0&id=3b920c94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b920c94",
  null
  
)

export default component.exports